import React from 'react'
import Link from 'gatsby-link'
import Drawer from '@material-ui/core/Drawer'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'

import slogo from '../../img/icons/slogo.svg'
import datascience from '../../img/logos/datascience.png'
import develop from '../../img/logos/develop.png'
import devops from '../../img/logos/devops.png'
import dynamics from '../../img/logos/dynamics.png'
import taas from '../../img/logos/taas.png'
import fixed from '../../img/logos/fixed.png'

import ct from '../../img/ct.png'

import { DRAWER } from '../../utils/constants'

class Navigation extends React.Component {
  render() {
    const { classes, open, toggle } = this.props
    return (
      <Drawer
        transitionDuration={{
          enter: DRAWER.enter,
          exit: DRAWER.exit,
        }}
        anchor="right"
        open={open}
        onClose={() => toggle()}
      >
        <nav className={classes.nav}>
          <Link to="/">
            <img
              src={ct}
              className={classes.navLogo}
              onClick={() => toggle()}
            />
          </Link>

          <div className={classes.navItems}>
            <Link to="/service/develop">
              <Typography
                gutterBottom={true}
                className={[classes.navItem, classes.navDevelop].join(' ')}
                onClick={() => toggle()}
              >
                <img src={develop} alt="Development logo" />Develop
              </Typography>
            </Link>
            <Link to="/service/dynamics_365">
              <Typography
                gutterBottom={true}
                className={[classes.navItem, classes.navDynamics].join(' ')}
                onClick={() => toggle()}
              >
                <img src={dynamics} alt="Dynamics logo" />Dynamics
              </Typography>
            </Link>
            <Link to="/service/devops">
              <Typography
                gutterBottom={true}
                className={[classes.navItem, classes.navDevops].join(' ')}
                onClick={() => toggle()}
              >
                <img src={devops} alt="Devops logo" />Devops
              </Typography>
            </Link>
            <Link to="/service/datascience">
              <Typography
                gutterBottom={true}
                className={[classes.navItem, classes.navDatascience].join(' ')}
                onClick={() => toggle()}
              >
                <img src={datascience} alt="Datascience logo" />DataScience
              </Typography>
            </Link>

            <div className={classes.divider} />

            <Link to="/method/ct-method-taas">
              <Typography
                gutterBottom={true}
                className={[classes.navItem, classes.navTaas].join(' ')}
                onClick={() => toggle()}
              >
                <img src={taas} alt="TaaS logo" />Team as a Service
              </Typography>
            </Link>
            <Link to="/method/ct-method-fixed">
              <Typography
                gutterBottom={true}
                className={[classes.navItem, classes.navFixed].join(' ')}
                onClick={() => toggle()}
              >
                <img src={fixed} alt="TaaS logo" />Fixed Price Projects
              </Typography>
            </Link>
            <Link to="/things">
              <Typography
                gutterBottom={true}
                className={classes.navItem}
                onClick={() => toggle()}
              >
                Products
              </Typography>
            </Link>
            <Link to="/blog">
              <Typography
                gutterBottom={true}
                className={classes.navItem}
                onClick={() => toggle()}
              >
                Blog
              </Typography>
            </Link>
            <Link to="/studies">
              <Typography
                gutterBottom={true}
                className={classes.navItem}
                onClick={() => toggle()}
              >
                Clients
              </Typography>
            </Link>
            <Link to="/careers">
              <Typography
                gutterBottom={true}
                className={classes.navItem}
                onClick={() => toggle()}
              >
                Careers
              </Typography>
            </Link>
            <Link to="/about">
              <Typography
                gutterBottom={true}
                className={classes.navItem}
                onClick={() => toggle()}
              >
                About
              </Typography>
            </Link>
            {/* <Link to="/policies" onClick={() => toggle()}>
              <Typography gutterBottom={true} className={classes.navItem}>
                Policies
              </Typography>
            </Link> */}
            <Link to="/contact">
              <Typography
                gutterBottom={true}
                className={classes.navItem}
                onClick={() => toggle()}
              >
                Contact
              </Typography>
            </Link>
            <Link to="/">
              <Typography
                gutterBottom={true}
                className={classes.navItem}
                onClick={() => toggle()}
              >
                Home
              </Typography>
            </Link>
          </div>
        </nav>
        {/* <div className={classes.navFooter}>
          <img src={slogo} alt="cloudThing logo" />
        </div> */}
      </Drawer>
    )
  }
}

export default withStyles(styles)(Navigation)



// WEBPACK FOOTER //
// ./src/components/nav/index.js